import request from '../../axios';

const getMyAccess = async (pageParam: number) => {
  const {data}: {data: IMyAccessResponse} = await request.get(
    '/api/v2/store/my-access',
    {
      params: {
        page: pageParam,
      },
    },
  );
  return data;
};

export default getMyAccess;
